function checkserialROO(serial) {
    var versionNode = document.getElementById('SingleOptionSelector-0');
    var version = versionNode && versionNode.value;
	if (((version === 'From Version 8') && (serial.match(/^R80(\d){6}$/i) && !serial.match(/^R80(0){6}$/i))) ||
        ((version === 'From Version 9') && (serial.match(/^R300(\d){5}$/i) && serial.toUpperCase() !== 'R30000000'))) {
        return true;
    } else {
        return false;
    }
}

function checkserialROO8(serial) {
    var version = 'From Version 8';
	if (((version === 'From Version 8') && (serial.match(/^R80(\d){6}$/i) && !serial.match(/^R80(0){6}$/i))) ||
        ((version === 'From Version 9') && (serial.match(/^R300(\d){5}$/i) && serial.toUpperCase() !== 'R30000000'))) {
        return true;
    } else {
        return false;
    }
}


function checkserialROOMS(serial) {
    if (serial.match(/^R300(\d){5}$/i) && serial.toUpperCase() !== 'R30000000') {
        return true;
    } else {
        return false;
    }
}

function checkserial(serial) {
    var versionNode = document.getElementById('SingleOptionSelector-0');
    var version = versionNode && versionNode.value;
  	var data_versions = document.getElementById('serial-number').getAttribute('data-versions');
  	var data_versions_array = data_versions.split(',');
  	var data_regexes = document.getElementById('serial-number').getAttribute('data-regexes');
  	var data_regexes_array = data_regexes.split(',');
  
  if (data_regexes_array.length > 1) {
    for (let i = 0; i < data_versions_array.length; i++) {
      if (data_versions_array[i] == version) {
          var regex = data_regexes_array[i];
          if (eval(regex))
            return true;
          else
            return false;
      }
    }
  } else {
     var regex = data_regexes_array[0];
    if (eval(regex)) {
     	return true;
    }
    else {
        return false;
    }
  }
  return false;
}



/*
function checkserialRWS(serial) {
    var versionNode = document.getElementById('SingleOptionSelector-0');
    var version = versionNode && versionNode.value;
    if ((version === 'Version 4' && serial.match(/^P40[12]0(\d){4}$/i)) ||
        (version === 'Version 3' && serial.match(/^RWS30(\d){6}$/i))) {
        return true;
    } else {
        return false;
    }
}

function checkserialRCO(serial) {
    var versionNode = document.getElementById('SingleOptionSelector-0');
    var version = versionNode && versionNode.value;
    if ((version === 'Version 5' && serial.match(/^C500(\d){5}$/i)) ||
        (version === 'Version 4' && serial.match(/^C4000(\d){4}$/i))) {
        return true;
    } else {
        return false;
    }
}



function checkserialRMS(serial) {
  	if (serial.match(/^R300(\d){5}$/i) && serial.toUpperCase() !== 'R30000000') {
        return true;
    } else {
        return false;
    }
}
*/
  
var validateRemarkRenewal = function(serial) {
  
  	if (checkserial(serial))
      return true;
  	else
      return false;

  	/* var product = window.location.pathname;
  
	if (product.indexOf('remark-office-omr-upgrade') > -1) {
      if (checkserialROO(serial)) {
          return true;
      } else {
          return false;
      }
    }
  	else if (product.indexOf('remark-office-omr-v11-upgrade-from-v8') > -1) {
      if (checkserialROO8(serial)) {
          return true;
      } else {
          return false;
      }
    }
  	else if (product.indexOf('remark-office-omr-maintenance-and-support-renewal') > -1) {
      if (checkserialROOMS(serial)) {
          return true;
      } else {
          return false;
      } 
    }
  	else if (product.indexOf('remark-office-omr-v11-upgrade-from-v') > -1) {
      if (checkserialROOMS(serial)) {
          return true;
      } else {
          return false;
      } 
    } /*
  
  	/*
	else if (product.indexOf('remark-web-survey-upgrade') > -1) {
      if (checkserialRWS(serial)) {
          return true;
      } else {
          return false;
      } 
  	} 
  	else if (product.indexOf('remark-classic-omr-upgrade')  > -1) {
      if (checkserialRCO(serial)) {
          return true;
      } else {
          return false;
      } 
    }
	else if (product.indexOf('remark-classic-omr-maintenance-and-support-renewal') > -1) {
        if (checkserialRMS(serial)) {
            return true;
        } else {
            return false;
        } 
    }
  	else {
  		return false;
  	} */
}